import { c as _c } from "react/compiler-runtime";
import clsx from "clsx";
import type { TokenMetadata } from "@/types/nft";
import { formatCount, formatXtdhRate, formatXtdhValue } from "../../utils/formatters";
import { XtdhContributorSummary } from "../../subcomponents/XtdhContributorSummary";
import { XtdhRatePill } from "../../collection-card-content/subcomponents/XtdhRatePill";
import { getTokenLabel } from "../utils/getTokenLabel";
import type { ApiXtdhToken } from "../types";
import { XtdhTokenListItemThumbnail } from "./XtdhTokenListItemThumbnail";
interface XtdhTokenListItemProps {
  readonly token: ApiXtdhToken;
  readonly metadata?: TokenMetadata | undefined;
  readonly isMetadataLoading: boolean;
  readonly hasMetadataError: boolean;
  readonly onSelect?: (() => void) | undefined;
  readonly as?: "li" | "div" | undefined;
  readonly className?: string | undefined;
}
export function XtdhTokenListItem(t0) {
  const $ = _c(45);
  const {
    token,
    metadata,
    isMetadataLoading,
    hasMetadataError,
    onSelect,
    as: t1,
    className
  } = t0;
  const as = t1 === undefined ? "li" : t1;
  let t2;
  if ($[0] !== token.token) {
    t2 = getTokenLabel(token.token);
    $[0] = token.token;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const tokenLabel = t2;
  let t3;
  if ($[2] !== token.xtdh) {
    t3 = formatXtdhValue(token.xtdh);
    $[2] = token.xtdh;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const xtdhValue = t3;
  let t4;
  if ($[4] !== token.xtdh_rate) {
    t4 = formatXtdhRate(token.xtdh_rate);
    $[4] = token.xtdh_rate;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const xtdhRateValue = t4;
  let t5;
  if ($[6] !== token.active_contributor_count) {
    t5 = formatCount(token.active_contributor_count);
    $[6] = token.active_contributor_count;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const activeContributors = t5;
  let t6;
  if ($[8] !== token.total_contributor_count) {
    t6 = formatCount(token.total_contributor_count);
    $[8] = token.total_contributor_count;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const totalContributors = t6;
  let t7;
  if ($[10] !== hasMetadataError || $[11] !== isMetadataLoading || $[12] !== metadata || $[13] !== tokenLabel) {
    t7 = <XtdhTokenListItemThumbnail tokenLabel={tokenLabel} metadata={metadata} isLoading={isMetadataLoading} hasError={hasMetadataError} />;
    $[10] = hasMetadataError;
    $[11] = isMetadataLoading;
    $[12] = metadata;
    $[13] = tokenLabel;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  const t8 = metadata?.name ?? tokenLabel;
  let t9;
  if ($[15] !== t8) {
    t9 = <p className="tw-m-0 tw-text-base tw-font-semibold tw-text-iron-50">{t8}</p>;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== tokenLabel) {
    t10 = <p className="tw-m-0 tw-text-xs tw-text-iron-500">{tokenLabel}</p>;
    $[17] = tokenLabel;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== t10 || $[20] !== t9) {
    t11 = <div className="tw-flex tw-flex-col tw-gap-0.5">{t9}{t10}</div>;
    $[19] = t10;
    $[20] = t9;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== t11 || $[23] !== t7) {
    t12 = <div className="tw-flex tw-flex-1 tw-items-center tw-gap-3">{t7}{t11}</div>;
    $[22] = t11;
    $[23] = t7;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== activeContributors || $[26] !== totalContributors) {
    t13 = <XtdhContributorSummary activeCount={activeContributors} totalCount={totalContributors} className="tw-text-left tw-order-3 lg:tw-order-2" />;
    $[25] = activeContributors;
    $[26] = totalContributors;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] !== xtdhRateValue || $[29] !== xtdhValue) {
    t14 = <XtdhRatePill rateLabel={xtdhRateValue} totalLabel={xtdhValue} className="tw-justify-start lg:tw-justify-end tw-mt-4 lg:tw-mt-0 tw-order-2 lg:tw-order-3" />;
    $[28] = xtdhRateValue;
    $[29] = xtdhValue;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  let t15;
  if ($[31] !== t12 || $[32] !== t13 || $[33] !== t14) {
    t15 = <div className="tw-flex tw-w-full tw-flex-col tw-gap-4 sm:tw-grid lg:tw-grid-cols-3 lg:tw-gap-4 tw-items-start">{t12}{t13}{t14}</div>;
    $[31] = t12;
    $[32] = t13;
    $[33] = t14;
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  const content = t15;
  const Wrapper = as === "div" ? "div" : "li";
  const t16 = as === "li" && "tw-list-none";
  let t17;
  if ($[35] !== className || $[36] !== t16) {
    t17 = clsx("tw-rounded-xl tw-border tw-border-solid tw-border-white/5 desktop-hover:hover:tw-border-white/10 tw-bg-iron-900 tw-transition-all tw-duration-300 desktop-hover:hover:tw-bg-iron-900/60 tw-p-4", t16, className);
    $[35] = className;
    $[36] = t16;
    $[37] = t17;
  } else {
    t17 = $[37];
  }
  const wrapperClassName = t17;
  let t18;
  if ($[38] !== content || $[39] !== onSelect) {
    t18 = onSelect ? <button type="button" onClick={onSelect} className="tw-flex tw-w-full tw-flex-col tw-gap-3 tw-rounded-xl tw-border-0 tw-bg-transparent tw-p-0 tw-text-left tw-text-inherit">{content}</button> : content;
    $[38] = content;
    $[39] = onSelect;
    $[40] = t18;
  } else {
    t18 = $[40];
  }
  let t19;
  if ($[41] !== Wrapper || $[42] !== t18 || $[43] !== wrapperClassName) {
    t19 = <Wrapper className={wrapperClassName}>{t18}</Wrapper>;
    $[41] = Wrapper;
    $[42] = t18;
    $[43] = wrapperClassName;
    $[44] = t19;
  } else {
    t19 = $[44];
  }
  return t19;
}